// extracted by mini-css-extract-plugin
export default {"commentInput":"comment-input_commentInput__4-pup","reply":"comment-input_reply__ICTIa","login":"comment-input_login__FOCUC"};